import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';

import 'animate.css';

import styles from './index.css';

const ModalComponent = ({ className, children, active, inline, onDeactive }) => (
	<CSSTransition
		in={active}
		classNames={{
			enter: 'animated',
			enterActive: 'fadeIn',
			exit: 'animated',
			exitActive: 'fadeOut',
		}}
		timeout={300}
		unmountOnExit
	>
		<div
			className={classnames(styles.modal, { [styles.inline]: inline }, className)}
			onClick={e => {
				if (e.target === e.currentTarget) {
					onDeactive(e);
				}
			}}
			role="presentation"
		>
			{children}
		</div>
	</CSSTransition>
);

class Modal extends React.PureComponent {
	constructor(props) {
		super(props);

		const { inline = false } = props;

		if (inline) {
			return;
		}

		this.modalRoot = document.getElementById('modal-root');

		if (this.modalRoot === null) {
			this.modalRoot = document.createElement('div');
			this.modalRoot.setAttribute('id', 'modal-root');
			document.body.appendChild(this.modalRoot);
		}

		this.el = document.createElement('div');
	}

	componentDidMount() {
		const { inline = false } = this.props;

		if (!inline) {
			this.modalRoot.appendChild(this.el);
		}
	}

	componentWillUnmount() {
		const { inline = false } = this.props;

		if (!inline) {
			this.modalRoot.removeChild(this.el);
		}
	}

	render() {
		const { children, inline = false, ...other } = this.props;

		if (inline) {
			return (
				<ModalComponent inline={inline} {...other}>
					{children}
				</ModalComponent>
			);
		}

		return ReactDOM.createPortal(<ModalComponent {...other}>{children}</ModalComponent>, this.el);
	}
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/component.js